import type { StationOption } from '../../types';
import SortIcon from '../../assets/sort.svg?react';

import styles from './stationSelector.module.css';

export interface StationSelectorProps {
  fromLabel: string;
  toLabel: string;
  swapLabel: string;
  fromStation?: StationOption;
  toStation?: StationOption;
  disabled?: boolean;
  onSelectFrom: () => void;
  onSelectTo: () => void;
  onSwap: () => void;
}

const StationSelector = ({
  fromLabel,
  toLabel,
  swapLabel,
  fromStation,
  toStation,
  disabled = false,
  onSelectFrom,
  onSelectTo,
  onSwap
}: StationSelectorProps) => (
  <div className={styles.card}>
    <button
      type="button"
      className={styles.station}
      disabled={disabled}
      onClick={onSelectFrom}
    >
      <span className={styles.label}>{fromLabel}</span>
      <span className={styles.name}>{fromStation?.name}</span>
    </button>
    <button
      type="button"
      className={styles.swap}
      aria-label={swapLabel}
      disabled={disabled}
      onClick={onSwap}
    >
      <SortIcon aria-hidden="true" className={styles.swapIcon} />
    </button>
    <button
      type="button"
      className={`${styles.station} ${styles.stationEnd}`}
      disabled={disabled}
      onClick={onSelectTo}
    >
      <span className={styles.label}>{toLabel}</span>
      <span className={styles.name}>{toStation?.name}</span>
    </button>
  </div>
);

export default StationSelector;
